// This file is here mostly so I can simplify the game while debugging,
// but still make changes to and commit App.js

import range from 'range';

function make_level(stage_count, notes_per_sequence, note_duration) {
  const sequence_count = notes_per_sequence.length;
  return {
    stage_count: stage_count,
    stage_indeces: range.range(stage_count),
    sequence_count: sequence_count,
    max_sequence_length: notes_per_sequence[sequence_count-1],
    notes_per_sequence: notes_per_sequence,
  }
}
export const LEVELS = [
  make_level(3, [1,2,3,4,5,6]),
  make_level(4, [1,2,3,4,5,6,7,8,9,10]),
  make_level(6, [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]),
];

export const START_HAND_IMMEDIATELY = true;



// WEBPACK FOOTER //
// ./src/config.js